import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/lunelle/Logo";
import { usePageMeta } from "@/lib/usePageMeta";
import { dailyEmailOff } from "@/lib/account-api";

export default function DailyEmailOffPage() {
  usePageMeta("Morning email stopped — Lunelle", "Stop the Lunelle morning email.");
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) { setState("invalid"); return; }
    dailyEmailOff(token).then(() => setState("done")).catch(() => setState("invalid"));
  }, [params]);
  return (
    <main className="mx-auto min-h-screen max-w-md px-5 py-10" data-testid="daily-email-off-page">
      <Link to="/" data-testid="daily-off-home-link"><Logo /></Link>
      <h1 className="mt-16 font-serif text-4xl font-light text-[#2C221E] sm:text-5xl" data-testid="daily-off-title">
        {state === "done" ? "Your morning email is off." : state === "invalid" ? "This link has expired." : "One moment..."}
      </h1>
      <p className="mt-4 text-[#5C4A42]">
        {state === "done" ? "You won't get it anymore. You can switch it back on anytime in My profile." : state === "invalid" ? "Sign in and turn the morning email off in My profile instead." : ""}
      </p>
      <Link to="/" className="mt-8 inline-block rounded-full bg-[#2C221E] px-6 py-3 text-sm font-semibold text-[#FBF5EE]">Back to Lunelle</Link>
    </main>
  );
}
